export default "__VITE_ASSET__1eoINyhl__"